import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  Auditoria,
  AuditoriaService,
  BaseResourceFormComponent, CodigoGps, EddyAutoComplete, Favorecido, FavorecidoBanco, FavorecidoCnae,
  FavorecidoContato, FavorecidoObservacao, FavorecidoPenalidade, FavorecidoPrestador, FavorecidoProduto,
  FavorecidoService, FavorecidoSocio, FavorecidoTerceiroSetor, FavorecidoTipo, FuncaoService, GlobalService,
  LoginContabil, TipoContato, TipoFavorecido, ViaCEPService
} from 'eddydata-lib';
import { MenuItem } from 'primeng/api';
import { InputMask } from 'primeng/inputmask';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { CodigoGpsService } from '../service/codigo-gps.service';
import { FavorecidoBancoService } from '../service/favorecido-banco.service';
import { FavorecidoCnaeService } from '../service/favorecido-cnae.service';
import { FavorecidoObservacaoService } from '../service/favorecido-observacao.service';
import { FavorecidoPenalidadeService } from '../service/favorecido-penalidade.service';
import { FavorecidoPrestadorService } from '../service/favorecido-prestador.service';
import { FavorecidoProdutoService } from '../service/favorecido-produto.service';
import { FavorecidoSocioService } from '../service/favorecido-socio.service';
import { FavorecidoTerceiroSetorService } from '../service/favorecido-terceiro-setor.service';
import { FavorecidoTipoService } from '../service/favorecido-tipo.service';

@Component({
  selector: 'lib-favorecido-frm',
  templateUrl: './favorecido-frm.component.html',
  styleUrls: ['./favorecido-frm.component.css']
})
export class FavorecidoFrmComponent extends BaseResourceFormComponent<Favorecido, LoginContabil> implements OnInit {

  /**
   * Declaração de variáveis
   */
  public codigoGpsAutoComplete: EddyAutoComplete<CodigoGps>;

  @ViewChild('tipo_') inputField: ElementRef;
  @ViewChild('cpf_') cpfField: ElementRef | InputMask;
  @ViewChild('numero_') numeroField: ElementRef;

  public listaTipos: Array<FavorecidoTipo>;
  public listaEnquadramento: Array<any>;
  public listaCnaes = new Array<any>();
  public listaContaBancos = new Array<any>();
  public listaPenalidades = new Array<any>();
  public listaObservacoes = new Array<any>();
  public listaProdutos: FavorecidoProduto[] = [];
  public listaEstados: any[];
  public listaTiposFavorecido: TipoFavorecido[] = [];
  public listaSocios: FavorecidoSocio[] = [];
  public listaContatos: FavorecidoContato[] = [];
  public listaTerceiroSetor: FavorecidoTerceiroSetor[] = [];
  public listaTomadores: FavorecidoPrestador[] = [];
  public historicoRazao: Array<any> = new Array<any>();

  public optionsContatos: MenuItem[] = [];
  public tab: number = 0;

  public uf: any;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    public globalService: GlobalService,
    protected funcaoService: FuncaoService,
    protected favorecidoBancoService: FavorecidoBancoService,
    protected favorecidoTipoService: FavorecidoTipoService,
    protected penalidadeService: FavorecidoPenalidadeService,
    protected favorecidoCnaeService: FavorecidoCnaeService,
    protected favorecidoService: FavorecidoService,
    protected favObsService: FavorecidoObservacaoService,
    protected favorecidoProdutoService: FavorecidoProdutoService,
    protected favorecidoSocioService: FavorecidoSocioService,
    protected favorecidoTerceiroSetorService: FavorecidoTerceiroSetorService,
    protected auditoriaService: AuditoriaService,
    private favorecidoPrestadorService: FavorecidoPrestadorService,
    private codigoGpsService: CodigoGpsService,
    protected viacepService: ViaCEPService) {
    super(new Favorecido(), injector, Favorecido.converteJson, favorecidoService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      cpf_cnpj: [null, [Validators.required]],
      tipo_favorecido: [TipoFavorecido.FORNECEDOR, [Validators.required]],
      nome: [null, [Validators.required]],
      nome_fantasia: [null, [Validators.required]],
      inscricao_estadual: [null],
      inscricao_municipal: [null],
      inscricao_inss: [null],
      cep: [null, [Validators.required]],
      endereco: [null, [Validators.required]],
      bairro: [null, [Validators.required]],
      num_endereco: [null, [Validators.required]],
      municipio: [null, [Validators.required]],
      uf: ['SP', [Validators.required, Validators.minLength(2)]],
      complemento: [null, [Validators.minLength(2)]],
      pis: [null],
      tipo: [null, [Validators.required]],
      autarquia: [false, [Validators.required]],
      autorizado: [true, [Validators.required]],
      inativo: [false, [Validators.required]],
      irrf: [false, [Validators.required]],
      inss: [false, [Validators.required]],
      servidor: [false, [Validators.required]],
      simples_nacional: [false, [Validators.required]],
      gasto_fixo: [false, [Validators.required]],
      cidade: [this.login.cidade, [Validators.required]],
      enquadramento: ['4', [Validators.required]],
      sistema: [this.login.sistema],
      cnaes: [],
      penalidades: [],
      contas: [],
      observacoes: [],
      produtos: [],
      socios: [],
      contatos: [],
      terceiro_setores: [],
      tomadores: [],
      gps: [null]
    });
  }

  protected parametrosExtras(): {} {
    return { relations: 'cidade,tipo,contatos,gps' };
  }

  protected afterLoad() {
    this.favorecidoCnaeService.filtrar(1, -1,
      { relations: 'cnae', 'favorecido.id': this.entidade.id, 'orderBy': 'principal$DESC' })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaCnaes = res ? res.content : new Array<FavorecidoCnae>();
      }, error => toastr.warning(error.error.payload));
    this.penalidadeService.filtrar(1, -1,
      { 'favorecido.id': this.entidade.id, orderBy: 'data_inicio$DESC' })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaPenalidades = res ? res.content : new Array<FavorecidoPenalidade>();
      }, error => toastr.warning(error.error.payload));
    this.favorecidoBancoService.filtrar(1, -1,
      { 'favorecido.id': this.entidade.id, relations: 'banco', orderBy: 'id$DESC' })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaContaBancos = res ? res.content : new Array<FavorecidoBanco>();
      }, error => toastr.warning(error.error.payload));
    this.favObsService.filtrar(1, -1,
      { relations: 'responsavel', 'favorecido.id': this.entidade.id, orderBy: 'data_cadastro$DESC' })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaObservacoes = res ? res.content : new Array<FavorecidoObservacao>();
      }, error => toastr.warning(error.error.payload));
    this.favorecidoProdutoService.filtrar(1, -1,
      { relations: 'produto', 'favorecido.id': this.entidade.id, orderBy: 'data_cadastro$DESC' })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaProdutos = res ? res.content : new Array<FavorecidoProduto>();
      }, error => toastr.warning(error.error.payload));

    this.favorecidoSocioService.filtrar(1, -1,
      { relations: 'pessoa', 'favorecido.id': this.entidade.id, orderBy: 'id$DESC' })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaSocios = res ? res.content : new Array<FavorecidoSocio>();
      }, error => toastr.warning(error.error.payload));

    this.favorecidoTerceiroSetorService.filtrar(1, -1, { 'favorecido.id': this.entidade.id, orderBy: 'id$DESC', relations: 'presidente' })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaTerceiroSetor = res ? res.content : new Array<FavorecidoTerceiroSetor>();
      }, error => toastr.warning(error.error.payload));

    this.favorecidoPrestadorService.filtrar(1, -1, { relations: 'favorecido,favorecido.cidade', 'prestador.id': this.entidade.id, orderBy: 'id$DESC' })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaTomadores = res ? res.content : new Array<FavorecidoPrestador>();
        console.log(this.listaTomadores)
      }, error => toastr.warning(error.error.payload));

    if (this.entidade != null && this.entidade.id != null && this.entidade.id != 0) {
      this.auditoriaService.filtrar(1, 10,
        {
          'alvo_id': this.entidade.id, 'alvo': 'Favorecido', 'depois$like': '%nome\":%',
          relations: 'usuario',
          orderBy: 'id$DESC'
        })
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          let dados: Array<Auditoria> = res.content;
          dados.forEach(d => {
            let info = {
              usuario: d.usuario.nome,
              data: d.data_alteracao,
              nome: d.depois['nome']
            }
            this.historicoRazao.push(info);
          });
        }, e => toastr.warning(e.error.payload));
    }

    this.uf = this.listaEstados.find((e) => e.uf === this.entidade.uf);
    this.listaContatos = this.entidade.contatos;
  }

  protected afterInit(): void {
    this.listaEnquadramento = this.globalService.obterListaEnquadramentoFornecedores();
    this.listaEstados = this.globalService.listaEstados();
    this.listaTiposFavorecido = this.globalService.tiposFavorecido();
    this.carregarAutoComplete();

    this.favorecidoTipoService.filtrar(1, -1, { 'cidade.id': this.login.cidade.id, orderBy: 'id' })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaTipos = res ? res.content : new Array<FavorecidoTipo>();
        if (this.listaTipos && this.listaTipos.length > 0 && !this.entidade.id)
          this.entidadeForm.get('tipo').setValue(this.listaTipos[0]);
      }, error => toastr.warning(error.error.payload));

    this.optionsContatos = [{
      label: 'Telefone',
      icon: 'fa fa-phone',
      command: (event) => {
        this.adicionarContato(TipoContato.TELEFONE);
      }
    }, {
      label: 'E-mail',
      icon: 'fa fa-envelope-open-text',
      command: (event) => {
        this.adicionarContato(TipoContato.EMAIL);
      }
    }, {
      label: 'Site',
      icon: 'fa fa-at',
      command: (event) => {
        this.adicionarContato(TipoContato.SITE);
      }
    }, {
      label: 'Outros',
      icon: 'fa fa-clipboard-list',
      command: (event) => {
        this.adicionarContato(TipoContato.OUTROS);
      }
    }];
  }

  protected campoFoco(): ElementRef {
    // return this.inputField;
    return null;
  }

  protected beforeSubmit() {
    try {
      if (this.entidadeForm.get('nome').value === null) {
        throw new Error('É necessário informar o nome do favorecido');
      }
      if (this.entidadeForm.get('cpf_cnpj').value === null) {
        throw new Error('É necessário informar cpf/cnpj/inscrição do favorecido');
      }
      this.entidadeForm.get('cnaes').setValue(this.listaCnaes);
      this.entidadeForm.get('penalidades').setValue(this.listaPenalidades);
      this.entidadeForm.get('contas').setValue(this.listaContaBancos);
      this.entidadeForm.get('observacoes').setValue(this.listaObservacoes);
      this.entidadeForm.get('produtos').setValue(this.listaProdutos);
      this.entidadeForm.get('socios').setValue(this.listaSocios);
      this.entidadeForm.get('uf').setValue(this.uf?.uf);
      this.entidadeForm.get('contatos').setValue(this.listaContatos);
      this.entidadeForm.get('terceiro_setores').setValue(this.listaTerceiroSetor);
      this.entidadeForm.get('tomadores').setValue(this.listaTomadores);
    } catch (e) {
      toastr.warning(e);
      throw e;
    }
  }

  protected afterSubmit(ent: Favorecido) {
    this.loadResource();
    window.scrollTo(0, 0);
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  private carregarAutoComplete() {
    this.codigoGpsAutoComplete = new EddyAutoComplete(null, this.codigoGpsService, 'id',
      ['descricao'], {}, { number: ['codigo'], text: ['descricao'] });
  }

  public buscarCEP() {
    let cep = this.entidadeForm.get('cep').value;
    if (!cep)
      return;
    this.buscaCEPForm(cep, ['bairro',
      { nome: 'localidade', campo: 'municipio' },
      { nome: 'logradouro', campo: 'endereco' },
      'uf'
    ], () => {
      let uf = this.entidadeForm.get('uf').value;
      this.uf = this.listaEstados.find((e) => e.uf === uf);
    });
    this.funcaoService.focarCampo(this.numeroField);
  }

  public filterEstado(event) {
    let query: string = event.query;
    this.listaEstados = this.globalService.listaEstados()
      .filter((e) => this.funcaoService.removerAcentos(e.nome)
        .toLowerCase().includes(this.funcaoService.removerAcentos(query).toLowerCase()));
  }

  public buscarReceitaFederal() {
    this.validarCPFCNPJ(() => {
      let cnpj = this.entidadeForm.get('cpf_cnpj').value;
      if (!this.entidadeForm.get('tipo').value || this.entidadeForm.get('tipo').value.tce !== '1'
        || !cnpj)
        return;
      cnpj = cnpj
        .replace(/[.]*[-]*[(]*[)]*/g, '');
      this.favorecidoService
        .buscarReceitaWS(cnpj, this.login.cidade.id).subscribe((data) => {
          if (!data) {
            toastr.warning('Dados não foram entrados no web service da receita!')
            return;
          }
          this.carregarDadosReceitaWs(data);
        });

    })
  }

  private carregarDadosReceitaWs(fav: Favorecido) {
    let favorecido = this.entidadeForm.value;
    favorecido = Object.assign(favorecido, fav);
    if (fav.contatos)
      this.listaContatos = fav.contatos;
    if (fav.cnaes)
      this.listaCnaes = fav.cnaes
    this.uf = this.listaEstados.find((e) => e.uf === fav.uf);
    this.entidadeForm.patchValue(favorecido);
  }

  public adicionarContato(tipo: TipoContato) {
    if (!this.listaContatos || this.listaContatos.length === 0) {
      this.listaContatos = new Array();
    } else {
      if (this.listaContatos.filter((e) => e['editavel']).length > 0) {
        return;
      }
    }
    let item = new FavorecidoContato();
    item.tipo = tipo;
    item['editavel'] = true;
    this.listaContatos.unshift(item);
  };

  public selecionatTab(tab: number) {
    this.tab = tab;
  }
  public tabSelecionado(tab: number) {
    return this.tab === tab;
  }

  public validarCPFCNPJ(callback?: () => void) {
    let cpf_cnpj = this.entidadeForm.get('cpf_cnpj').value;
    if (!cpf_cnpj)
      return;
    this.favorecidoService.obter({ 'cpf_cnpj': cpf_cnpj })
      .subscribe((data) => {
        if (data && data.id !== this.entidade.id) {
          toastr.warning('CPF/CNPJ já cadastrado em outro fornecedor/credor.')
          this.entidadeForm.get('cpf_cnpj').setValue(null);
          this.funcaoService.focarCampo(this.cpfField);
        } else {
          callback();
        }
      })
  }
}
